<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="detailPath" label="详细图：" :show-message="!formData.detailPath">
                        <img-upload
                            :url.sync="formData.detailPath" 
                            :urlFull.sync="formData.detailPath" 
                            :crop="true"
                            :width="1125" 
                            :height="1200" 
                            class="detailImg">
                        </img-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">                    
                    <el-form-item prop="title" label="主题标题：">
                        <el-input
                            v-model.trim="formData.title"
                            placeholder="请输入主题标题"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="subTitle" label="主题副标题：">
                        <el-input
                            v-model.trim="formData.subTitle"
                            placeholder="请输入主题副标题"
                            size="medium"
                        ></el-input>
                    </el-form-item>
					<el-form-item prop="sort" label="序号:">
					    <el-input
					        v-model="formData.sort"
					        placeholder="请输入序号"
					        type="number"
					        size="medium"
					    ></el-input>
					</el-form-item> 
                </el-col>
            </el-row>            
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="shopGoods" :show-message="!formData.shopGoods">
                        <span slot="label">关联商品:  <small class="from-tip"><span class="el-icon-warning"></span> 请输入商品ID进行搜索</small></span>
                        <el-input v-if="$utils.have('/shop_good/detail')" v-model="goodsParams.id" placeholder="请输入商品ID" size="medium">
                            <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
                        </el-input>
                        <el-table
                            :data="formData.shopGoods"
                            border
                            style="width: 100%"
                            size="small"
                            class="MT10"
                            v-loading="eventLoading"
							v-if="formData.shopGoods && formData.shopGoods.length > 0"
                        >
                            <el-table-column prop="id" label="商品ID"></el-table-column>
                            <el-table-column prop="name" label="商品名称"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="small"
                                        icon="el-icon-delete"
                                        @click="delGoods(scope.row)"
                                        >删除</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>               
            </el-row>            
            <el-row :gutter="30">
                <el-col<el-col :xs="24" :xl="16">
                    <el-form-item prop="description" :show-message="formData.description ? false : true">
                        <span slot="label">主题简介: </span>
                       <tinymce v-model="formData.description" :height="500" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
                    </el-form-item>
                </el-col>               
            </el-row>           
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </div>
</template>

<script>

const defaultFormData = {
    title: "",
    subTitle:"",
	detailPath:'',
	sort:'',
	shopGoods:[],
	description:''
}
import ImgUpload from '@/components/ImageUpload';
import Tinymce from '@/components/Tinymce'; 

export default {
   props: {
       id: {
           type: [String, Number],
           default: ""
       }
   },
    components:{ImgUpload,Tinymce},
    data() {
        return {
        	toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media | preview fullscreen'],
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },			
            rules: {
                // title: [{ required: true, message: "请输入主题标题" }],
                // subTitle: [{ required: true, message: "请输入主题副标题" }],
        		sort: [{ required: true, message: "请输入序号" }],
        		detailPath: [{ required: true, message: "请上传详情图" }],				
                shopGoods: [{ required: true, message: "请输入关联商品" }],
            },           
            eventLoading: false,
            goodsParams:{
                id:''
            },
			reFresh:false,
        };
    },
    mounted() {
		if (this.id) {
		    this.getDataDetail();
		} else {
		    this.formData = {
		        ...defaultFormData		       
		    }
		    this.reFresh = true;
			this.formData.shopGoods = []
		}
    },
    methods: {
       //获取详情
       getDataDetail() {
           this.dataLoading = true;
           this.$request({
               url: "/shoptheme/detail",
               params: { id: this.id },
               method: "post",
           })
               .then((res) => {
                   const { state, msg, result } = res.data;
                   if (state == 1 && result) {
                       this.formData = {
                           ...defaultFormData,
                           ...result,
                       }; 
						this.reFresh = true;
                   } else {
                       this.$message.error(msg || "获取信息失败,请重试");
                   }
               }).catch(() => {
                   this.$message.error("获取信息失败,请重试");
               }).finally(() => {
                   this.dataLoading = false;
               })
               
       },
       //搜索商品
       searchEvent(){
           if(this.goodsParams.id !== ""){
               this.eventLoading = true;
               this.$request({
                   url: "/shop_good/getCanUseBaseById",
                   params: this.goodsParams,
                   method: "post",
               })
                   .then((res) => {
                       const { state, msg, result } = res.data;
                       if (state == 1 && result) {
                           const _obj = this.formData.shopGoods.find(v => v.id == result.id && v.name == result.name);
                           if(!_obj){
                               this.formData.shopGoods.push({
                                   id: result.id,
                                   name:result.name
                               });
                           }
                       }else{
                           this.$message.error(msg || '没有找到相关商品');
                       }
                   })
                   .catch(() => {
                       this.$message.error('系统错误');
                   }).finally(() => {
                       this.eventLoading = false;
                   });
           }  
       },
       //删除商品
       delGoods(v){
           this.$confirm('确定要删除吗？', '提示', {
               type: 'warning',
               center: true,
               closeOnClickModal: false
           }).then(() => {
               this.formData.shopGoods =this.formData.shopGoods.filter( item => item !== v);
           }).catch(() => {})
       },
       //表单提交
       submitForm() {
           this.$refs["formData"].validate((valid) => {
               if (valid) {
                   const _url = "/shoptheme/saveOrUpdate";
                   this.btnLoading = true;
                   this.$request({
                       url: _url,
                       data: this.formData,
                       method: "post",
                   })
                       .then((res) => {
                           const { state, msg } = res.data;
                           if (state == 1) {
							   if( this.id ){
								   this.$confirm('是否返回列表', '操作成功', {
								       type: 'success',
								       center: true,
								       confirmButtonText:'返回列表',
								       cancelButtonText:'留在当前页面',
								       closeOnClickModal: false
								   }).then(() => {
								       this.goBack();
								   }).catch(() => {
								       this.getDataDetail();
								   })
							   }else{
								   this.$message.success("操作成功");
								   this.goBack();
								   
							   }                              
                               
                           } else {
                               this.$message.error(msg || "操作失败,请重试");
                           }
                       })
                       .catch(() => {
                           this.$message.error("操作失败,请重试");
                       })
                       .finally(() => {
                           this.btnLoading = false;
                       });
               } else {
                   return false;
               }
           });
       },
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
		
    }
}
</script>